module.exports = __webpack_public_path__ + "img/Slice2en-min.fcee8b99.png";